import { render, staticRenderFns } from "./InviteUser.vue?vue&type=template&id=2c1c1600&scoped=true&"
import script from "./InviteUser.vue?vue&type=script&lang=js&"
export * from "./InviteUser.vue?vue&type=script&lang=js&"
import style0 from "./InviteUser.vue?vue&type=style&index=0&id=2c1c1600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c1600",
  null
  
)

export default component.exports